import 'select2';
import 'jquery-mask-plugin'
import 'select2/dist/css/select2';

import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $(document).on('click', '.card', function () {
      $(this).find(".btn").toggle();
    });

    $('.select2-multiple').select2({
      multiple: true,
      placeholder: 'Todos(as)',
      allowClear: true
    });

    $('.months-range').mask("9?9");
    $('.days-range').mask("9?9");
  }
}
